import { Reducer } from 'redux';

import { ApiUserAddress } from '#/api/types';
import { changeUser } from '#/reduxState/currentUser/currentUserReducer';

type UserAddressAction = ReturnType<typeof changeUser>;

type UserAddress = ApiUserAddress & {
  defined: boolean;
};

const defaultState = {
  defined: false,

  buildingNumber: '',
  country: '',
  postcode: '',
  state: '',
  street: '',
  town: '',
};

export const userAddressReducer: Reducer<UserAddress, UserAddressAction> = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case 'CHANGE_USER': {
      if (!action.loggedIn) {
        return defaultState;
      }
      if (!action?.extendedData?.address) {
        return state;
      }
      const newState = {
        ...state,
        ...action?.extendedData?.address,
        defined: true,
      };
      if (JSON.stringify(state) === JSON.stringify(newState)) {
        // Prevent state mutation when not needed
        return state;
      }
      return newState;
    }
    default:
      return state;
  }
};
